export enum FollowerFilter {
  LowerBound = 1,
  UpperBound = 1000000,
}
